import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

/** The helpdesk (Zammad) logs its users in through PCSBG as OpenID Connect provider. The backend's
 *  authorize endpoint cannot see the browser's PCSBG session, so it sends the browser to the login
 *  page with the authorize request as returnUrl. Once logged in, the page asks the backend for a
 *  one-time login ticket and returns the browser to that request with the ticket attached. */
@Injectable({
    providedIn: 'root'
})
export class HelpdeskSsoService {
    constructor(private http: HttpClient) {}

    /** True for the backend's OpenID Connect authorize endpoint. Which host is trusted is decided by the
     *  backend when it issues the ticket, so nothing is ever redirected without its consent. */
    isAuthorizeUrl(returnUrl: string): boolean {
        if (!returnUrl) {
            return false;
        }
        try {
            const url = new URL(returnUrl);
            return (
                (url.protocol === 'http:' || url.protocol === 'https:') &&
                url.pathname.toLowerCase().endsWith('/connect/authorize')
            );
        } catch {
            return false;
        }
    }

    async continueToHelpdesk(authorizeUrl: string): Promise<void> {
        const response = await firstValueFrom(
            this.http.post<{ ticket: string }>('api:///authentication/HelpdeskLoginTicket', { authorizeUrl })
        );
        const url = new URL(authorizeUrl);
        url.searchParams.set('login_ticket', response.ticket);
        window.location.href = url.toString();
    }
}
